import React from 'react';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import moment from "moment-timezone";
import { FaTimesCircle } from 'react-icons/fa';
import { useLanguage } from '../../../contexts/LanguageContext';
import { isParsable } from '../../../utils/commonUtils';
import { FaCircleInfo } from 'react-icons/fa6';
import { localizePrice } from '../../_helpers';
import { MediaCell } from './ExpandedDetails';

export const MockShortListColumn = (language,themeData) => [
  
    {
        Header:language.CCMODE_SHORTLISTPAGE_SHORTLISTID,
        accessor:'ConsumerId',
        className:"align-middle text-center",
        show: false
    },
    
    {
        Header:language.CCMODE_SHORTLISTPAGE_SHORTLISTNAME,
        accessor:'ListName',
        className:"align-middle text-center",
    },
    {
        Header:language.CCMODE_THEME3_CONSUMERNAME,
        accessor:'ConsumerName',
        className:"align-middle text-center",
    },
    {
        Header:language.CCMODE_THEME3_EMAIL,
        accessor:'EMail',
        className:"align-middle text-center",
    },
    {
        Header:language.CCMODE_SHORTLISTPAGE_CONTACT_NUMBER,
        accessor:'ContactNo',
        className:"align-middle text-center",
    },
   
    {
        Header:language.CCMODE_SHORTLISTPAGE_NOOFSTONES,
        accessor:'ShortListedStones',
        className:"text-center align-middle",
    },
    {
        Header:language.CCMODE_SHORTLISTPAGE_TOTALCARAT,
        accessor:'TotalCarats',
        className:"text-center align-middle",
    },
    {
        Header:language.CCMODE_SHORTLISTPAGE_NOTES,
        minwidth: 100,
        accessor:'Notes',
        className:"align-middle text-center",
        Cell: (row) => {
            return (
                <>
                    <OverlayTrigger
                        placement="left"
                        overlay={
                            <Tooltip id="tooltip">{row.value}</Tooltip>
                        }
                    >
                        <span
                            className="d-inline-block text-truncate text-dark"
                            style={{ maxWidth: "120px" }}
                        >
                            {row.value}
                        </span>
                    </OverlayTrigger>
                </>
            );
        },
    },
    {
        Header:language.CCMODE_SHORTLISTPAGE_CREATEDDATE,
        // accessor:'CreatedAt',
        accessor: (d) => {
            return (
                <>
                {/* { console.log("d.CreatedAt",d.CreatedAt)}
                { console.log("themeData",themeData.timeZone)} */}
                    {  d.CreatedAt ? moment.tz(d.CreatedAt, themeData.timeZone ? themeData.timeZone : "Etc/GMT").format("YYYY-MM-DD HH:mm:ss") : "-"}
                </>
            );
        },
        className:"text-center align-middle",
    },
]

export const MockOrderHistoryColumn = (
    language,
    themeData,
    hideCertificateNumber,
    hidePrice,
) => [
    {
        Header: "ConsumerId",
        accessor: "ConsumerId",
        show: false,
    },
    {
        Header: language.CCMODE_SHORTLISTPAGE_SHORTLISTNAME,
        accessor: "ListName",
        className: "align-middle text-center text-nowrap",
    },
    {
        Header: language.CCMODE_SHORTLISTPAGE_DIAMONDTYPE,
        accessor: "WLDiamondType",
        className: "align-middle text-center",
        Cell: ({ value }) =>
            value === "N"
                ? language.CCMODE_CART_NATURAL
                : language.CCMODE_CART_LAB,
    },
    {
        Header: language.CCMODE_CART_STATUS,
        id: "Status",
        className: "align-middle text-center text-nowrap",
        Cell: ({ row }) => (
            <StockStatusForOrderHistory
                data={row.original}
                language={language}
            />
        ),
    },
    {
        Header: language.CCMODE_THEME1_LIST_MEDIA,
        id: "Media",
        className: "align-middle text-center",
        Cell: ({ row }) => (
            <MediaCell
                val={row.original}
                language={language}
            />
        ),
    },
    {
        Header: "Diamond Details",
        id: "DiamondDetails",
        className: "align-middle text-left text-nowrap",
        Cell: ({ row }) => (
            <DiamondDetailsCell
                row={row}
                hideCertificateNumber={hideCertificateNumber}
            />
        ),
    },
    ...(!hidePrice
        ? [
              {
                  Header: language.CCMODE_SHORTLISTPAGE_CURRENCY,
                  accessor: "Currency",
                  className: "align-middle text-center",
              },
              {
                  Header: "$/CT",
                  accessor:
                      "SELECTED_CURRENCY_LIST_PRICE_PER_CARAT",
                  className: "align-middle text-right",
                  Cell: ({ row }) => (
                      <PricePerCaratCell val={row.original} />
                  ),
              },
              {
                  Header: language.CCMODE_SHORTLISTPAGE_PRICE,
                  accessor: "SELECTED_CURRENCY_LIST_PRICE",
                  className: "align-middle text-right",
                  Cell: ({ row }) => (
                      <TotalPriceCell val={row.original} />
                  ),
              },
          ]
        : []),
    {
        Header: language.CCMODE_THEME1_LIST_MEASUREMENT,
        id: "Measurement",
        className: "align-middle text-center text-nowrap",
        Cell: ({ row }) =>
            `${Number(row.original.C_Length || 0).toFixed(2)}x${Number(
                row.original.C_Width || 0,
            ).toFixed(2)}x${Number(
                row.original.C_Depth || 0,
            ).toFixed(2)}`,
    },
    {
        Header: `${language.CCMODE_THEME1__LIST_DEPTH} %`,
        accessor: "C_DefthP",
        className: "align-middle text-center",
        Cell: ({ value }) => Number(value || 0).toFixed(2),
    },
    {
        Header: `${language.CCMODE_THEME1__LIST_TABLE} %`,
        accessor: "C_TableP",
        className: "align-middle text-center",
        Cell: ({ value }) => Number(value || 0).toFixed(2),
    },
    {
        Header: language.CCMODE_SHORTLISTPAGE_CREATEDDATE,
        accessor: "CreatedAt",
        className: "align-middle text-center text-nowrap",
        Cell: ({ value }) =>
            value
                ? moment
                      .tz(
                          value,
                          themeData?.timeZone || "Etc/GMT",
                      )
                      .format("YYYY-MM-DD HH:mm:ss")
                : "-",
    },
    {
        Header: language.CCMODE_SHORTLISTPAGE_CLIENTREF,
        accessor: "client_ref",
        className: "align-middle text-center text-nowrap",
    },
];

const StockStatusForOrderHistory = React.memo(({ data, language }) => {
    const message = data?.CURRENT_STATUS?.message;

    if (message === "Purchased") {
        return (
            <div
                className="label label-outline-info label-pill label-inline bg-info-o-30 px-5"
                style={{ width: "max-content" }}
            >
                {language.CCMODE_CART_PURCHASED}
            </div>
        );
    }

    if (message === "Already Hold By You") {
        const isOutOfStock = Number(data?.Status) === 1;

        return (
            <div
                className="label label-outline-warning label-pill label-inline bg-warning-o-30"
                style={{ width: "max-content" }}
            >
                {isOutOfStock && (
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip id={`status-${data?.Id}`}>
                                {language.CCMODE_CART_OUT_OF_STOCK}
                            </Tooltip>
                        }
                    >
                        <FaTimesCircle className="text-danger mr-2 font-size-sm" />
                    </OverlayTrigger>
                )}

                {language.CCMODE_CART_BUY_REQUEST}
            </div>
        );
    }

    return null;
});

const PricePerCaratCell = React.memo(({ val }) => {
    const parsable = isParsable(val.SELECTED_CURRENCY_LIST_PRICE);

    return parsable ? (
        val.SELECTED_CURRENCY_LIST_PRICE_PER_CARAT_LABEL
    ) : (
        "-"
    );
});

const TotalPriceCell = React.memo(({ val }) => {
    const language = useLanguage();
    const parsable = isParsable(val.SELECTED_CURRENCY_LIST_PRICE);

    return (
        <span
            className="d-inline-flex align-items-center"
            style={{ whiteSpace: "nowrap" }}
        >
            {parsable ? (
                <>
                    {val.SELECTED_CURRENCY_LIST_PRICE_LABEL}

                    {val.taxBreakDown && (
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip id="tax-breakdown-tooltip">
                                    {val.taxBreakDown}
                                </Tooltip>
                            }
                        >
                            <span className="ml-2 d-inline-flex align-items-center cursor-pointer">
                                <FaCircleInfo
                                    size={16}
                                    style={{ color: "#B5B5C3" }}
                                />
                            </span>
                        </OverlayTrigger>
                    )}
                </>
            ) : (
                localizePrice(
                    val.SELECTED_CURRENCY_LIST_PRICE,
                    language,
                )
            )}
        </span>
    );
});

const DiamondDetailsCell = ({ row, hideCertificateNumber }) => {
    const val = row.original;

    return (
        <div className="pl-2 p-0 text-left">
            <div className="mb-1 text-nowrap">
                <a
                    href={`/details/confirm-${val.conform_good_id}`}
                    target="_blank"
                    rel="noreferrer"
                    className="cursor-pointer small mr-3"
                >
                    {val.WLDiamondType}-{val.ProductId}
                </a>
                {!hideCertificateNumber && val.CERTIFICATE_LINK && (
                    <a
                        href={val.CERTIFICATE_LINK}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="small"
                    >
                        {val.Lab}: {val.Certi_No}
                    </a>
                )}
            </div>
            <span className="text-dark font-weight-bold d-block text-nowrap">
                {val.C_Shape} {Number(val.C_Weight || 0).toFixed(2)}{" "}
                {val.C_Color} {val.C_Cut} {val.C_Clarity}{" "}
                {val.C_Polish} {val.C_Symmetry} {val.C_Fluorescence}
            </span>
        </div>
    );
};